module.exports = __webpack_public_path__ + "static/img/privacy-8-2.8673dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-8-2.png
// module id = oPNj
// module chunks = 1